import React, { useState } from "react";
import { Accordion, Icon } from "semantic-ui-react";
import { useTranslation } from "react-i18next";
import step1 from "../../images/Problems/step1.webp";
import step2 from "../../images/Problems/step2.webp";
import step3 from "../../images/Problems/step3.webp";
import step4 from "../../images/Problems/step4.webp";
import step5 from "../../images/Problems/step5.webp";

const CommomProblems = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const { t } = useTranslation();
  const i18n = (key) => t(`commomProblems.${key}`);

  const handleClick = (e, titleProps) => {
    const { index } = titleProps;
    setActiveIndex((prevIndex) => (prevIndex === index ? -1 : index));
  };

  return (
    <section className="w-full mt-[10px] px-[10px] py-[16px] bg-base-light-white dark:bg-base-light-dark mb-[15px]">
      <h1 className="text-center my-2 !mt-2 text-base-light-dark dark:text-base-light-white text-xl md:text-3xl font-semibold">
        {i18n("Common problems")}
      </h1>
      <div className="text-base-deep-dark w-full dark:text-base-light-white">
        <div className="p-8 font-normal">
          <Accordion>
            <Accordion.Title
              active={activeIndex === 0}
              index={0}
              onClick={handleClick}
              className="flex items-center"
            >
              <Icon name="dropdown" />
              <h1 className="!my-2 text-base-light-dark dark:text-base-light-white text-xl font-semibold">
                {i18n("question1")}
              </h1>
            </Accordion.Title>
            <Accordion.Content active={activeIndex === 0} className="!pl-6">
              <div className="mb-6 flex flex-col">{i18n("ans1")}</div>
              <div className="mb-6 flex flex-col">
                {i18n("ans1_1")}
                <br></br>
                <image src={step1} alt="" className="w-full" />
              </div>
              <div className="mb-6 flex flex-col">
                {i18n("ans1_2")}
                <br></br>
                <image src={step2} alt="" className="w-full" />
              </div>
              <div className="mb-6 flex flex-col">
                {i18n("ans1_3")}
                Ltd. Corp」<br></br>
                <image src={step3} alt="" className="w-full" />
              </div>
              <div className="mb-6 flex flex-col">
                {i18n("ans1_4")}
                <br></br>
                <image src={step4} alt="" className="w-full" />
              </div>
              <div className="mb-6 flex flex-col">
                {i18n("ans1_5")}
                <br></br>
                <image src={step5} alt="" className="w-full" />
              </div>
            </Accordion.Content>

            <Accordion.Title
              active={activeIndex === 1}
              index={1}
              onClick={handleClick}
              className="flex items-center"
            >
              <Icon name="dropdown" />
              <h1 className="!my-2 text-base-light-dark dark:text-base-light-white text-xl font-semibold">
                {i18n("question2")}
              </h1>
            </Accordion.Title>
            <Accordion.Content active={activeIndex === 1} className="!pl-6">
              <div className="mb-6 flex flex-col">{i18n("ans2")}</div>
            </Accordion.Content>

            <Accordion.Title
              active={activeIndex === 2}
              index={2}
              onClick={handleClick}
              className="flex items-center"
            >
              <Icon name="dropdown" />
              <h1 className="!my-2 text-base-light-dark dark:text-base-light-white text-xl font-semibold">
                {i18n("question3")}
              </h1>
            </Accordion.Title>
            <Accordion.Content active={activeIndex === 2} className="!pl-6">
              <div className="mb-6 flex flex-col">{i18n("ans3")}</div>
            </Accordion.Content>
            <Accordion.Title
              active={activeIndex === 3}
              index={3}
              onClick={handleClick}
              className="flex items-center"
            >
              <Icon name="dropdown" />
              <h1 className="!my-2 text-base-light-dark dark:text-base-light-white text-xl font-semibold">
                {i18n("question4")}
              </h1>
            </Accordion.Title>
            <Accordion.Content active={activeIndex === 3} className="!pl-6">
              <div className="mb-6 flex flex-col">{i18n("ans4")}</div>
            </Accordion.Content>
            <Accordion.Title
              active={activeIndex === 4}
              index={4}
              onClick={handleClick}
              className="flex items-center"
            >
              <Icon name="dropdown" />
              <h1 className="!my-2 text-base-light-dark dark:text-base-light-white text-xl font-semibold">
                {i18n("question5")}
              </h1>
            </Accordion.Title>
            <Accordion.Content active={activeIndex === 4} className="!pl-6">
              <div className="mb-6 flex flex-col">
                {i18n("ans5")}
                <br></br>
                {i18n("ans5-1")}
              </div>
            </Accordion.Content>
            <Accordion.Title
              active={activeIndex === 5}
              index={5}
              onClick={handleClick}
              className="flex items-center"
            >
              <Icon name="dropdown" />
              <h1 className="!my-2 text-base-light-dark dark:text-base-light-white text-xl font-semibold">
                {i18n("question6")}
              </h1>
            </Accordion.Title>
            <Accordion.Content active={activeIndex === 5} className="!pl-6">
              <div className="mb-6 flex flex-col">{i18n("ans6")}</div>
            </Accordion.Content>
            <Accordion.Title
              active={activeIndex === 6}
              index={6}
              onClick={handleClick}
              className="flex items-center"
            >
              <Icon name="dropdown" />
              <h1 className="!my-2 text-base-light-dark dark:text-base-light-white text-xl font-semibold">
                {i18n("question7")}
              </h1>
            </Accordion.Title>
            <Accordion.Content active={activeIndex === 6} className="!pl-6">
              <div className="mb-6 flex flex-col">{i18n("ans7")}</div>
            </Accordion.Content>
            <Accordion.Title
              active={activeIndex === 7}
              index={7}
              onClick={handleClick}
              className="flex items-center"
            >
              <Icon name="dropdown" />
              <h1 className="!my-2 text-base-light-dark dark:text-base-light-white text-xl font-semibold">
                {i18n("question8")}
              </h1>
            </Accordion.Title>
            <Accordion.Content active={activeIndex === 7} className="!pl-6">
              <div className="mb-6 flex flex-col">{i18n("ans8")}</div>
            </Accordion.Content>
            <Accordion.Title
              active={activeIndex === 8}
              index={8}
              onClick={handleClick}
              className="flex items-center"
            >
              <Icon name="dropdown" />
              <h1 className="!my-2 text-base-light-dark dark:text-base-light-white text-xl font-semibold">
                {i18n("question9")}
              </h1>
            </Accordion.Title>
            <Accordion.Content active={activeIndex === 8} className="!pl-6">
              <div className="mb-6 flex flex-col">{i18n("ans9")}</div>
            </Accordion.Content>
            <Accordion.Title
              active={activeIndex === 9}
              index={9}
              onClick={handleClick}
              className="flex items-center"
            >
              <Icon name="dropdown" />
              <h1 className="!my-2 text-base-light-dark dark:text-base-light-white text-xl font-semibold">
                {i18n("question10")}
              </h1>
            </Accordion.Title>
            <Accordion.Content active={activeIndex === 9} className="!pl-6">
              <div className="mb-6 flex flex-col">{i18n("ans10")}</div>
            </Accordion.Content>
            <Accordion.Title
              active={activeIndex === 10}
              index={10}
              onClick={handleClick}
              className="flex items-center"
            >
              <Icon name="dropdown" />
              <h1 className="!my-2 text-base-light-dark dark:text-base-light-white text-xl font-semibold">
                {i18n("question11")}
              </h1>
            </Accordion.Title>
            <Accordion.Content active={activeIndex === 10} className="!pl-6">
              <div className="mb-6 flex flex-col">
                {i18n("ans11")}

                <br></br>
                {i18n("ans11-1")}
              </div>
            </Accordion.Content>
            <Accordion.Title
              active={activeIndex === 11}
              index={11}
              onClick={handleClick}
              className="flex items-center"
            >
              <Icon name="dropdown" />
              <h1 className="!my-2 text-base-light-dark dark:text-base-light-white text-xl font-semibold">
                {i18n("question12")}
              </h1>
            </Accordion.Title>
            <Accordion.Content active={activeIndex === 11} className="!pl-6">
              <div className="mb-6 flex flex-col">{i18n("ans12")}</div>
            </Accordion.Content>
            <Accordion.Title
              active={activeIndex === 12}
              index={12}
              onClick={handleClick}
              className="flex items-center"
            >
              <Icon name="dropdown" />
              <h1 className="!my-2 text-base-light-dark dark:text-base-light-white text-xl font-semibold">
                {i18n("question13")}
              </h1>
            </Accordion.Title>
            <Accordion.Content active={activeIndex === 12} className="!pl-6">
              <div className="mb-6 flex flex-col">{i18n("ans13")}</div>
            </Accordion.Content>
            <Accordion.Title
              active={activeIndex === 13}
              index={13}
              onClick={handleClick}
              className="flex items-center"
            >
              <Icon name="dropdown" />
              <h1 className="!my-2 text-base-light-dark dark:text-base-light-white text-xl font-semibold">
                {i18n("question14")}
              </h1>
            </Accordion.Title>
            <Accordion.Content active={activeIndex === 13} className="!pl-6">
              <div className="mb-6 flex flex-col">{i18n("ans14")}</div>
            </Accordion.Content>
            <Accordion.Title
              active={activeIndex === 14}
              index={14}
              onClick={handleClick}
              className="flex items-center"
            >
              <Icon name="dropdown" />
              <h1 className="!my-2 text-base-light-dark dark:text-base-light-white text-xl font-semibold">
                {i18n("question15")}
              </h1>
            </Accordion.Title>
            <Accordion.Content active={activeIndex === 14} className="!pl-6">
              <div className="mb-6 flex flex-col">{i18n("ans15")}</div>
            </Accordion.Content>
            <Accordion.Title
              active={activeIndex === 15}
              index={15}
              onClick={handleClick}
              className="flex items-center"
            >
              <Icon name="dropdown" />
              <h1 className="!my-2 text-base-light-dark dark:text-base-light-white text-xl font-semibold">
                {i18n("question16")}
              </h1>
            </Accordion.Title>
            <Accordion.Content active={activeIndex === 15} className="!pl-6">
              <div className="mb-6 flex flex-col">{i18n("ans16")}</div>
            </Accordion.Content>
            <Accordion.Title
              active={activeIndex === 16}
              index={16}
              onClick={handleClick}
              className="flex items-center"
            >
              <Icon name="dropdown" />
              <h1 className="!my-2 text-base-light-dark dark:text-base-light-white text-xl font-semibold">
                {i18n("question17")}
              </h1>
            </Accordion.Title>
            <Accordion.Content active={activeIndex === 16} className="!pl-6">
              <div className="mb-6 flex flex-col">{i18n("ans17")}</div>
            </Accordion.Content>
            <Accordion.Title
              active={activeIndex === 17}
              index={17}
              onClick={handleClick}
              className="flex items-center"
            >
              <Icon name="dropdown" />
              <h1 className="!my-2 text-base-light-dark dark:text-base-light-white text-xl font-semibold">
                {i18n("question18")}
              </h1>
            </Accordion.Title>
            <Accordion.Content active={activeIndex === 17} className="!pl-6">
              <div className="mb-6 flex flex-col">
                {i18n("ans18")}
                <br></br>
                {i18n("ans18-1")}
              </div>
            </Accordion.Content>
          </Accordion>
        </div>
      </div>
    </section>
  );
};

export default CommomProblems;
